var React = require('react');

function Arrow45 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Rectangle_869","data-name":"Rectangle 869","fill":"#fff","stroke":"#707070","strokeWidth":"1","opacity":"0","key":0},[React.createElement("rect",{"width":"32.284","height":"32.284","stroke":"none","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"31.284","height":"31.284","fill":"none","key":1})]),React.createElement("path",{"id":"Path_2377","data-name":"Path 2377","d":"M-14348.051,238.107l3.585-3.474H-14372v-1.264h27.533l-3.585-3.474.922-.894,5.13,4.974-5.13,5.026Z","transform":"translate(10002.609 -10301.252) rotate(-45)","fill":"#000f10","key":1})]);
}

Arrow45.defaultProps = {"id":"arrow_45","data-name":"arrow 45","width":"32.284","height":"32.285","viewBox":"0 0 32.284 32.285"};

module.exports = Arrow45;

Arrow45.default = Arrow45;
